import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Row, Col } from 'react-bootstrap';
import { Sprawy } from '../../sprawy/Sprawy';
import s from '../../content.scss';
import PaperHeader from '../../../components/PaperHeader/PaperHeader';
import { connect } from 'react-redux';
import { headerStyle, getThemeFromLocalStorage, isMobileView, isTabletView } from '../../../components/utils/utils';
import Button from 'react-bootstrap/lib/Button';
import ServicesLayout from '../../../components/ServicesLayout';
import EmptyFileDownloader from '../../../components/EmptyFileDownloader';

const btnStyle = {
  borderRadius: 0,
  padding: '10px 40px',
};

class KartaEuslugi extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      colors: 'normal',
      style: {},
      isMounted: false,

      cardInfo: {
        organ: 'Nie określono',
        dotyczy: 'Nie określono',
        podstawa: ['Nie określono'],
        dokumenty: ['Nie określono'],
        czas: 'Nie określono',
        oplaty: ['Nie określono'],
        tryb: 'Nie określono',
        rezultat: 'Nie określono',
        etapy: ['Nie określono'],
        poziom_uwierzytelniania: ['Nie określono'],
        logowanie: 'Nie określono',
      },
    };
  }

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let style = {};
    if (colors !== 'normal') {
      style = {
        color: headerStyle[colors].color,
        backgroundColor: headerStyle[colors].backgroundColor,
      };
    }
    this.setState({ colors, style }, () => this.getDataForCard());
  }

  getDataForCard = () => {
    fetch(`${process.env.API_URL}/eservices/service_card/${this.props.district}/${this.props.shortName}/`)
    .then(r => r.json())
    .then(resp => {
      this.setState({ cardInfo: resp, isMounted: true });
    });
  }

  render() {
    let isMobile = false;
    if (this.state.isMounted) {
      isMobile = isMobileView(window);
    }
    const showFileButton = this.props.districts[this.props.prefix].emptyDocFileDownloadEnabled;
    const start = this.props.district === 1020043 ? "eservices" : "eservices";
    const href = `/${start}?district=${this.props.district}&serviceType=${this.props.shortName}`;
    return this.state.isMounted? (
      <div>
        <div>
          <PaperHeader title={this.props.title} />
          <div className="paper-area" style={this.state.style}>

            <Col xs={12} sm={8}>
              {this.props.district ?
                <div style={{ marginBottom: '20px' }}>
                  {isMobile ?
                    <Row className="eus-specs">
                      <Col xs={1} />
                      <Col xs={10} style={{display: 'grid', alignItems: 'center'}}>
                        <a
                          href={href}
                          className="btn btn-primary"
                          style={{ ...btnStyle, padding: isMobile ? '10px 10px' : '10px 40px'}}
                        >
                          <b>Przejdź do formularza</b>
                        </a>
                      </Col>
                      <Col xs={1} />
                    </Row> 
                  : null}
                  {isMobile && showFileButton ?
                    <Row className="eus-specs">
                      <Col xs={1} />
                      <Col xs={10} style={{display: 'grid', alignItems: 'center'}}>
                        <EmptyFileDownloader prefix={this.props.prefix} serviceType={this.props.shortName} />
                      </Col>
                      <Col xs={1} />
                    </Row> 
                  : null}
                  {showFileButton && !isMobile ? 
                    <Row className="eus-specs">
                      <Col xs={1} />
                      <Col xs={isMobile? 10: 5} style={{display: 'grid', alignItems: 'center'}}>
                        <EmptyFileDownloader prefix={this.props.prefix} serviceType={this.props.shortName} />
                      </Col>
                      <Col xs={5} style={{display: 'grid', alignItems: 'center'}}>
                        <a
                          href={href}
                          className="btn btn-primary"
                          style={{ ...btnStyle, padding: '10px 40px'}}
                        >
                          <b>Przejdź do formularza</b>
                        </a>
                      </Col>
                      <Col xs={1} />
                    </Row>
                    : null
                    }
                    {!showFileButton && !isMobile ? 
                    <Row className="eus-specs">
                      <Col xs={4} />
                      <Col xs={4} style={{display: 'grid', alignItems: 'center'}}>
                        <a
                          href={href}
                          className="btn btn-primary"
                          style={{ ...btnStyle, padding: '10px 40px'}}
                        >
                          <b>Przejdź do formularza</b>
                        </a>
                      </Col>
                      <Col xs={4} />
                    </Row> : null}
                </div> : null}
              <Row className="eus-specs">
                <Col xs={3}>Organ właściwy do realizacji usługi:</Col>
                <Col xs={9}><span style={{ whiteSpace: "pre-line" }}>{this.state.cardInfo.organ}</span></Col>
              </Row>
              <Row className="eus-specs">
                <hr />
              </Row>
              <Row className="eus-specs">
                <Col xs={3}>Kogo dotyczy:</Col>
                <Col xs={9}><span style={{ whiteSpace: "pre-line" }}>{this.state.cardInfo.dotyczy}</span></Col>
              </Row>
              <Row className="eus-specs">
                <hr />
              </Row>
              <Row className="eus-specs">
                <Col xs={3}>Podstawy prawne:</Col>
                <Col xs={9}>
                  {this.state.cardInfo.podstawa.map((item, i) => (
                    <div key={i}><span style={{ whiteSpace: "pre-line" }}>{item}</span></div>
                  ))}
                </Col>
              </Row>
              <Row className="eus-specs">
                <hr />
              </Row>
              <Row className="eus-specs">
                <Col xs={3}>Wymagane dokumenty:</Col>
                <Col xs={9}>
                  {this.state.cardInfo.dokumenty.map((item, i) => (
                    <div key={i}><span style={{ whiteSpace: "pre-line" }}>{item}</span></div>
                  ))}
                </Col>
              </Row>
              <Row className="eus-specs">
                <hr />
              </Row>
              <Row className="eus-specs">
                <Col xs={3}>Czas realizacji:</Col>
                <Col xs={9}><span style={{ whiteSpace: "pre-line" }}>{this.state.cardInfo.czas}</span></Col>
              </Row>
              <Row className="eus-specs">
                <hr />
              </Row>
              <Row className="eus-specs">
                <Col xs={3}>Opłaty:</Col>
                <Col xs={9}>
                  {this.state.cardInfo.oplaty.map((item, i) => (
                    <div key={i}><span style={{ whiteSpace: "pre-line" }}>{item}</span></div>
                  ))}
                </Col>
              </Row>
              <Row className="eus-specs">
                <hr />
              </Row>
              <Row className="eus-specs">
                <Col xs={3}>Tryb odwoławczy:</Col>
                <Col xs={9}><span style={{ whiteSpace: "pre-line" }}>{this.state.cardInfo.tryb}</span></Col>
              </Row>
              <Row className="eus-specs">
                <hr />
              </Row>
              <Row className="eus-specs">
                <Col xs={3}>Rezultat realizacji usługi:</Col>
                <Col xs={9}><span style={{ whiteSpace: "pre-line" }}>{this.state.cardInfo.rezultat}</span></Col>
              </Row>
              <Row className="eus-specs">
                <hr />
              </Row>
              <Row className="eus-specs">
                <Col xs={3}>Etapy realizacji usługi:</Col>
                <Col xs={9}>
                  {this.state.cardInfo.etapy.map((item, i) => (
                    <div key={i}><span style={{ whiteSpace: "pre-line" }}>{item}</span></div>
                  ))}
                </Col>
              </Row>
              <Row className="eus-specs">
                <hr />
              </Row>
              <Row className="eus-specs">
                <Col xs={3}>Poziom uwierzytelniania:</Col>
                <Col xs={9}>
                  {this.state.cardInfo.poziom_uwierzytelniania.map((item, i) => (
                    <div key={i}><span style={{ whiteSpace: "pre-line" }}>{item}</span></div>
                  ))}
                </Col>
              </Row>
              <Row className="eus-specs">
                <hr />
              </Row>
              <Row className="eus-specs">
                <Col xs={3}>Usługa wymaga zalogowania:</Col>
                <Col xs={9}><span style={{ whiteSpace: "pre-line" }}>{this.state.cardInfo.logowanie}</span></Col>
              </Row>
            </Col>
          </div>
        </div>
      </div>
    ) : null;
  }
}

KartaEuslugi.propTypes = {
  prefix: PropTypes.string,
};

const mapState = state => ({
  eservices: state.district.eservices,
  districts: state.district.districts,
});

export default withStyles(s)(connect(mapState)(KartaEuslugi));



// WEBPACK FOOTER //
// src/routes/euslugi/kartaEuslugi/KartaEuslugi.js